import React from 'react'

const Footer = ({children}) => {
    return <div className="footer-overlay">
    {children}
    </div>
}

export default Footer